export default __webpack_public_path__ + "static/media/green-industry.328180c6.jpg";